import React from 'react'
import { Navigate, Outlet, useParams } from 'react-router'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'

import useApplicantTokenOnMount from '@sputnik/hooks/useApplicantTokenOnMount'
import useGetCreditAppTypes from '@sputnik/hooks/useGetCreditAppTypes'
import { PATHNAME_CONSTS } from '@sputnik/resources/constants'

import MXConnectionStatusProvider from './ConnectBankAccountForm/MXConnectionStatusProvider'
import Navigation from './Navigation'
import styles from './styles.module.scss'

const CreditApplicationPage = () => {
  const { appId } = useParams()
  const [getClassName] = useNameFormatter('CreditApplicationPage')
  useApplicantTokenOnMount({ salesforceCreditId: appId ?? '' })

  const { isEditable, isLoadingCreditAppTypes } = useGetCreditAppTypes({ salesforceCreditId: appId ?? '' })

  if (!isLoadingCreditAppTypes && !isEditable) {
    return <Navigate to={PATHNAME_CONSTS.DASHBOARD_PATH} />
  }

  return (
    <MXConnectionStatusProvider>
      <div className={styles[getClassName('')]}>
        <Navigation />
        <div className={styles[getClassName('outlet')]}>
          {/* form for each page gets rendered here through routes */}
          <Outlet />
        </div>
      </div>
    </MXConnectionStatusProvider>
  )
}

export default CreditApplicationPage
